// Action types for setting state
export const SET_COMMUNITY_PROFILE_CURRENT = 'SET_COMMUNITY_PROFILE_CURRENT'
export const SET_COMMUNITY_PROFILE_CURRENT_PROCESSING = 'SET_COMMUNITY_PROFILE_CURRENT_PROCESSING'
export const SET_COMMUNITY_PROFILE_CURRENT_ERROR = 'SET_COMMUNITY_PROFILE_CURRENT_ERROR'

export const SET_COMMUNITY_PROFILE_MEMBER = 'SET_COMMUNITY_PROFILE_MEMBER'
export const SET_COMMUNITY_PROFILE_MEMBER_PROCESSING = 'SET_COMMUNITY_PROFILE_MEMBER_PROCESSING'
export const SET_COMMUNITY_PROFILE_MEMBER_ERROR = 'SET_COMMUNITY_PROFILE_MEMBER_ERROR'

export const SET_COMMUNITY_PROFILE_UPDATE_PROCESSING = 'SET_COMMUNITY_PROFILE_UPDATE_PROCESSING'
export const SET_COMMUNITY_PROFILE_UPDATE_SUCCESS = 'SET_COMMUNITY_PROFILE_UPDATE_SUCCESS'
export const SET_COMMUNITY_PROFILE_UPDATE_ERROR = 'SET_COMMUNITY_PROFILE_UPDATE_ERROR'

export const SET_COMMUNITY_PROFILE_FOLLOW_PROCESSING = 'SET_COMMUNITY_PROFILE_FOLLOW_PROCESSING'
export const SET_COMMUNITY_PROFILE_FOLLOW_ERROR = 'SET_COMMUNITY_PROFILE_FOLLOW_ERROR'

export const SET_COMMUNITY_PROFILE_ACTIVE_TAB = 'SET_COMMUNITY_PROFILE_ACTIVE_TAB'
export const SET_COMMUNITY_PROFILE_WELCOME_DISMISSED = 'SET_COMMUNITY_PROFILE_WELCOME_DISMISSED'

export const SET_COMMUNITY_PROFILE_TAG_OPTIONS = 'SET_COMMUNITY_PROFILE_TAG_OPTIONS'
export const SET_COMMUNITY_PROFILE_TAG_OPTIONS_PROCESSING = 'SET_COMMUNITY_PROFILE_TAG_OPTIONS_PROCESSING'
export const SET_COMMUNITY_PROFILE_TAG_OPTIONS_ERROR = 'SET_COMMUNITY_PROFILE_TAG_OPTIONS_ERROR'

export const SET_COMMUNITY_PROFILE_FOLLOWERS = 'SET_COMMUNITY_PROFILE_FOLLOWERS'
export const SET_COMMUNITY_PROFILE_FOLLOWERS_PROCESSING = 'SET_COMMUNITY_PROFILE_FOLLOWERS_PROCESSING'
export const SET_COMMUNITY_PROFILE_FOLLOWERS_ERROR = 'SET_COMMUNITY_PROFILE_FOLLOWERS_ERROR'
export const SET_COMMUNITY_PROFILE_FOLLOWING = 'SET_COMMUNITY_PROFILE_FOLLOWING'
export const SET_COMMUNITY_PROFILE_FOLLOWING_PROCESSING = 'SET_COMMUNITY_PROFILE_FOLLOWING_PROCESSING'
export const SET_COMMUNITY_PROFILE_FOLLOWING_ERROR = 'SET_COMMUNITY_PROFILE_FOLLOWING_ERROR'

export const SET_COMMUNITY_PROFILE_ACTIVITY_FILTER = 'SET_COMMUNITY_PROFILE_ACTIVITY_FILTER'

export const SET_COMMUNITY_PROFILE_PLAYLISTS = 'SET_COMMUNITY_PROFILE_PLAYLISTS'
export const SET_COMMUNITY_PROFILE_PLAYLISTS_PROCESSING = 'SET_COMMUNITY_PROFILE_PLAYLISTS_PROCESSING'

export const SET_COMMUNITY_PROFILE_WATCHING_TAGS = 'SET_COMMUNITY_PROFILE_WATCHING_TAGS'
export const SET_COMMUNITY_PROFILE_WATCHING_TAGS_PROCESSING = 'SET_COMMUNITY_PROFILE_WATCHING_TAGS_PROCESSING'

export const SET_COMMUNITY_PROFILE_IN_PROGRESS = 'SET_COMMUNITY_PROFILE_IN_PROGRESS'
export const SET_COMMUNITY_PROFILE_IN_PROGRESS_PROCESSING = 'SET_COMMUNITY_PROFILE_IN_PROGRESS_PROCESSING'

export const SET_COMMUNITY_PROFILE_COMMUNITY_SPACES = 'SET_COMMUNITY_PROFILE_COMMUNITY_SPACES'
export const SET_COMMUNITY_PROFILE_COMMUNITY_SPACES_PROCESSING = 'SET_COMMUNITY_PROFILE_COMMUNITY_SPACES_PROCESSING'

export const SET_COMMUNITY_PROFILE_ACTIVITY_SUMMARY = 'SET_COMMUNITY_PROFILE_ACTIVITY_SUMMARY'
export const SET_COMMUNITY_PROFILE_ACTIVITY_SUMMARY_PROCESSING = 'SET_COMMUNITY_PROFILE_ACTIVITY_SUMMARY_PROCESSING'

export const SET_COMMUNITY_PROFILE_PLAYLIST_VISIBILITY = 'SET_COMMUNITY_PROFILE_PLAYLIST_VISIBILITY'
export const SET_COMMUNITY_PROFILE_SHARED_PLAYLIST_DETAILS = 'SET_COMMUNITY_PROFILE_SHARED_PLAYLIST_DETAILS'

export const SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_PROCESSING = 'SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_PROCESSING'
export const SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_SUCCESS = 'SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_SUCCESS'
export const SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_ERROR = 'SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_ERROR'
export const SET_COMMUNITY_PROFILE_AVATAR_DELETE_PROCESSING = 'SET_COMMUNITY_PROFILE_AVATAR_DELETE_PROCESSING'
export const SET_COMMUNITY_PROFILE_AVATAR_DELETE_SUCCESS = 'SET_COMMUNITY_PROFILE_AVATAR_DELETE_SUCCESS'
export const SET_COMMUNITY_PROFILE_AVATAR_DELETE_ERROR = 'SET_COMMUNITY_PROFILE_AVATAR_DELETE_ERROR'

// Action types for triggering watchers
export const COMMUNITY_PROFILE_FETCH_CURRENT = 'COMMUNITY_PROFILE_FETCH_CURRENT'
export const COMMUNITY_PROFILE_FETCH_MEMBER = 'COMMUNITY_PROFILE_FETCH_MEMBER'
export const COMMUNITY_PROFILE_UPDATE = 'COMMUNITY_PROFILE_UPDATE'
export const COMMUNITY_PROFILE_FOLLOW = 'COMMUNITY_PROFILE_FOLLOW'
export const COMMUNITY_PROFILE_UNFOLLOW = 'COMMUNITY_PROFILE_UNFOLLOW'
export const COMMUNITY_PROFILE_FETCH_TAG_OPTIONS = 'COMMUNITY_PROFILE_FETCH_TAG_OPTIONS'
export const COMMUNITY_PROFILE_FETCH_FOLLOWERS = 'COMMUNITY_PROFILE_FETCH_FOLLOWERS'
export const COMMUNITY_PROFILE_FETCH_FOLLOWING = 'COMMUNITY_PROFILE_FETCH_FOLLOWING'
export const COMMUNITY_PROFILE_FETCH_PLAYLISTS = 'COMMUNITY_PROFILE_FETCH_PLAYLISTS'
export const COMMUNITY_PROFILE_FETCH_WATCHING_TAGS = 'COMMUNITY_PROFILE_FETCH_WATCHING_TAGS'
export const COMMUNITY_PROFILE_FETCH_IN_PROGRESS = 'COMMUNITY_PROFILE_FETCH_IN_PROGRESS'
export const COMMUNITY_PROFILE_FETCH_COMMUNITY_SPACES = 'COMMUNITY_PROFILE_FETCH_COMMUNITY_SPACES'
export const COMMUNITY_PROFILE_FETCH_ACTIVITY_SUMMARY = 'COMMUNITY_PROFILE_FETCH_ACTIVITY_SUMMARY'
export const COMMUNITY_PROFILE_UPDATE_PLAYLIST_VISIBILITY = 'COMMUNITY_PROFILE_UPDATE_PLAYLIST_VISIBILITY'

export const SET_COMMUNITY_PROFILE_PICTURES = 'SET_COMMUNITY_PROFILE_PICTURES'
export const SET_COMMUNITY_PROFILE_PICTURES_PROCESSING = 'SET_COMMUNITY_PROFILE_PICTURES_PROCESSING'
export const SET_COMMUNITY_PROFILE_PICTURES_ERROR = 'SET_COMMUNITY_PROFILE_PICTURES_ERROR'

export const COMMUNITY_PROFILE_FETCH_PROFILE_PICTURES = 'COMMUNITY_PROFILE_FETCH_PROFILE_PICTURES'

export const COMMUNITY_PROFILE_ENRICH_SHARED_PLAYLISTS = 'COMMUNITY_PROFILE_ENRICH_SHARED_PLAYLISTS'

export const COMMUNITY_PROFILE_UPLOAD_AVATAR = 'COMMUNITY_PROFILE_UPLOAD_AVATAR'
export const COMMUNITY_PROFILE_DELETE_AVATAR = 'COMMUNITY_PROFILE_DELETE_AVATAR'

// ── Watcher-trigger action creators ──────────────────────────────────

export function fetchCurrentProfile (language) {
  return {
    type: COMMUNITY_PROFILE_FETCH_CURRENT,
    payload: { language },
  }
}

export function fetchMemberProfile (uid, language) {
  return {
    type: COMMUNITY_PROFILE_FETCH_MEMBER,
    payload: { uid, language },
  }
}

export function updateProfile (input) {
  return {
    type: COMMUNITY_PROFILE_UPDATE,
    payload: { input },
  }
}

export function followUser (uid) {
  return {
    type: COMMUNITY_PROFILE_FOLLOW,
    payload: { uid },
  }
}

export function unfollowUser (uid) {
  return {
    type: COMMUNITY_PROFILE_UNFOLLOW,
    payload: { uid },
  }
}

export function fetchTagOptions (language) {
  return {
    type: COMMUNITY_PROFILE_FETCH_TAG_OPTIONS,
    payload: { language },
  }
}

export function fetchFollowers (uid, first, after) {
  return {
    type: COMMUNITY_PROFILE_FETCH_FOLLOWERS,
    payload: { uid, first, after },
  }
}

export function fetchFollowing (uid, first, after) {
  return {
    type: COMMUNITY_PROFILE_FETCH_FOLLOWING,
    payload: { uid, first, after },
  }
}

export function setActiveTab (tab) {
  return {
    type: SET_COMMUNITY_PROFILE_ACTIVE_TAB,
    payload: tab,
  }
}

export function dismissWelcomeBanner () {
  return {
    type: SET_COMMUNITY_PROFILE_WELCOME_DISMISSED,
    payload: true,
  }
}

export function setActivityFilter (filter) {
  return {
    type: SET_COMMUNITY_PROFILE_ACTIVITY_FILTER,
    payload: filter,
  }
}

export function fetchPlaylists () {
  return {
    type: COMMUNITY_PROFILE_FETCH_PLAYLISTS,
  }
}

export function fetchWatchingTags () {
  return {
    type: COMMUNITY_PROFILE_FETCH_WATCHING_TAGS,
  }
}

export function fetchInProgress () {
  return {
    type: COMMUNITY_PROFILE_FETCH_IN_PROGRESS,
  }
}

export function fetchCommunitySpaces () {
  return {
    type: COMMUNITY_PROFILE_FETCH_COMMUNITY_SPACES,
  }
}

export function fetchActivitySummary () {
  return {
    type: COMMUNITY_PROFILE_FETCH_ACTIVITY_SUMMARY,
  }
}

export function updatePlaylistVisibility (playlistId, visibility) {
  return {
    type: COMMUNITY_PROFILE_UPDATE_PLAYLIST_VISIBILITY,
    payload: { playlistId, visibility },
  }
}

export function enrichSharedPlaylists (playlists, isOwner) {
  return {
    type: COMMUNITY_PROFILE_ENRICH_SHARED_PLAYLISTS,
    payload: { playlists, isOwner },
  }
}

export function uploadAvatar ({ imageBlob, fileExtension }) {
  return {
    type: COMMUNITY_PROFILE_UPLOAD_AVATAR,
    payload: { imageBlob, fileExtension },
  }
}

export function deleteAvatar () {
  return {
    type: COMMUNITY_PROFILE_DELETE_AVATAR,
  }
}

export function fetchProfilePictures (uids) {
  return {
    type: COMMUNITY_PROFILE_FETCH_PROFILE_PICTURES,
    payload: { uids },
  }
}

// ── SET_* action creators (used by watchers) ─────────────────────────

export function setCurrentProfile (payload) {
  return {
    type: SET_COMMUNITY_PROFILE_CURRENT,
    payload,
  }
}

export function setCurrentProfileProcessing (processing) {
  return {
    type: SET_COMMUNITY_PROFILE_CURRENT_PROCESSING,
    payload: processing,
  }
}

export function setCurrentProfileError (error) {
  return {
    type: SET_COMMUNITY_PROFILE_CURRENT_ERROR,
    payload: error,
  }
}

export function setMemberProfile (payload) {
  return {
    type: SET_COMMUNITY_PROFILE_MEMBER,
    payload,
  }
}

export function setMemberProfileProcessing (processing) {
  return {
    type: SET_COMMUNITY_PROFILE_MEMBER_PROCESSING,
    payload: processing,
  }
}

export function setMemberProfileError (error) {
  return {
    type: SET_COMMUNITY_PROFILE_MEMBER_ERROR,
    payload: error,
  }
}

export function setUpdateProcessing (processing) {
  return {
    type: SET_COMMUNITY_PROFILE_UPDATE_PROCESSING,
    payload: processing,
  }
}

export function setUpdateSuccess (payload) {
  return {
    type: SET_COMMUNITY_PROFILE_UPDATE_SUCCESS,
    payload,
  }
}

export function setUpdateError (error) {
  return {
    type: SET_COMMUNITY_PROFILE_UPDATE_ERROR,
    payload: error,
  }
}

export function setFollowProcessing (processing) {
  return {
    type: SET_COMMUNITY_PROFILE_FOLLOW_PROCESSING,
    payload: processing,
  }
}

export function setFollowError (error) {
  return {
    type: SET_COMMUNITY_PROFILE_FOLLOW_ERROR,
    payload: error,
  }
}

export function setTagOptions (payload) {
  return {
    type: SET_COMMUNITY_PROFILE_TAG_OPTIONS,
    payload,
  }
}

export function setTagOptionsProcessing (processing) {
  return {
    type: SET_COMMUNITY_PROFILE_TAG_OPTIONS_PROCESSING,
    payload: processing,
  }
}

export function setTagOptionsError (error) {
  return {
    type: SET_COMMUNITY_PROFILE_TAG_OPTIONS_ERROR,
    payload: error,
  }
}

export function setFollowers (payload) {
  return {
    type: SET_COMMUNITY_PROFILE_FOLLOWERS,
    payload,
  }
}

export function setFollowersProcessing (processing) {
  return {
    type: SET_COMMUNITY_PROFILE_FOLLOWERS_PROCESSING,
    payload: processing,
  }
}

export function setFollowersError (error) {
  return {
    type: SET_COMMUNITY_PROFILE_FOLLOWERS_ERROR,
    payload: error,
  }
}

export function setFollowing (payload) {
  return {
    type: SET_COMMUNITY_PROFILE_FOLLOWING,
    payload,
  }
}

export function setFollowingProcessing (processing) {
  return {
    type: SET_COMMUNITY_PROFILE_FOLLOWING_PROCESSING,
    payload: processing,
  }
}

export function setFollowingError (error) {
  return {
    type: SET_COMMUNITY_PROFILE_FOLLOWING_ERROR,
    payload: error,
  }
}

export function setPlaylists (payload) {
  return {
    type: SET_COMMUNITY_PROFILE_PLAYLISTS,
    payload,
  }
}

export function setPlaylistsProcessing (processing) {
  return {
    type: SET_COMMUNITY_PROFILE_PLAYLISTS_PROCESSING,
    payload: processing,
  }
}

export function setWatchingTags (payload) {
  return {
    type: SET_COMMUNITY_PROFILE_WATCHING_TAGS,
    payload,
  }
}

export function setWatchingTagsProcessing (processing) {
  return {
    type: SET_COMMUNITY_PROFILE_WATCHING_TAGS_PROCESSING,
    payload: processing,
  }
}

export function setInProgress (payload) {
  return {
    type: SET_COMMUNITY_PROFILE_IN_PROGRESS,
    payload,
  }
}

export function setInProgressProcessing (processing) {
  return {
    type: SET_COMMUNITY_PROFILE_IN_PROGRESS_PROCESSING,
    payload: processing,
  }
}

export function setCommunitySpaces (payload) {
  return {
    type: SET_COMMUNITY_PROFILE_COMMUNITY_SPACES,
    payload,
  }
}

export function setCommunitySpacesProcessing (processing) {
  return {
    type: SET_COMMUNITY_PROFILE_COMMUNITY_SPACES_PROCESSING,
    payload: processing,
  }
}

export function setActivitySummary (payload) {
  return {
    type: SET_COMMUNITY_PROFILE_ACTIVITY_SUMMARY,
    payload,
  }
}

export function setActivitySummaryProcessing (processing) {
  return {
    type: SET_COMMUNITY_PROFILE_ACTIVITY_SUMMARY_PROCESSING,
    payload: processing,
  }
}

export function setAvatarUploadProcessing (processing) {
  return {
    type: SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_PROCESSING,
    payload: processing,
  }
}

export function setAvatarUploadSuccess () {
  return {
    type: SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_SUCCESS,
  }
}

export function setAvatarUploadError (error) {
  return {
    type: SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_ERROR,
    payload: error,
  }
}

export function setAvatarDeleteProcessing (processing) {
  return {
    type: SET_COMMUNITY_PROFILE_AVATAR_DELETE_PROCESSING,
    payload: processing,
  }
}

export function setAvatarDeleteSuccess () {
  return {
    type: SET_COMMUNITY_PROFILE_AVATAR_DELETE_SUCCESS,
  }
}

export function setAvatarDeleteError (error) {
  return {
    type: SET_COMMUNITY_PROFILE_AVATAR_DELETE_ERROR,
    payload: error,
  }
}

export function setSharedPlaylistDetails (payload) {
  return {
    type: SET_COMMUNITY_PROFILE_SHARED_PLAYLIST_DETAILS,
    payload,
  }
}

export function setProfilePictures (payload) {
  return {
    type: SET_COMMUNITY_PROFILE_PICTURES,
    payload,
  }
}

export function setProfilePicturesProcessing (processing) {
  return {
    type: SET_COMMUNITY_PROFILE_PICTURES_PROCESSING,
    payload: processing,
  }
}

export function setProfilePicturesError (error) {
  return {
    type: SET_COMMUNITY_PROFILE_PICTURES_ERROR,
    payload: error,
  }
}
